import { useMutation } from '@tanstack/solid-query'
import { native } from '@forest/native-services'
import { getServiceClient } from '~/lib/api'
import { queryClient } from '~/lib/query-client'
import { focusChallengesKey } from './focus-challenges'
import { specialChallengeProgressKey } from './special-challenge'

export type GrantedContentType =
  | 'coin'
  | 'gem'
  | 'tree_type'
  | 'sound'
  | 'sunshine'
  | 'land_skin'
  | 'game_pass'

export type GrantedContent = {
  type: GrantedContentType
  value: number
  title_key: string
  icon_image_url: string
}

export type ClaimRewardResponse = {
  reward: {
    id: number
    claimed_at: string
    item_type_id: number
  }
  granted_contents: GrantedContent[]
  draw_results: unknown[]
}

export function useClaimRewardMutation() {
  return useMutation(() => ({
    mutationFn: async (progressId: number): Promise<ClaimRewardResponse> => {
      const { client, userId } = await getServiceClient()
      return await client
        .put(`challenge/users/${userId}/progresses/${progressId}/reward`)
        .json<ClaimRewardResponse>()
    },
    onSuccess: () => {
      void native.data.fullSync()
      queryClient.invalidateQueries({ queryKey: focusChallengesKey })
      queryClient.invalidateQueries({ queryKey: specialChallengeProgressKey })
    },
  }))
}
